<template>
  <div
    class="imageGeneration"
    :class="
      Number(data.appInfo.creation_type) === 1 ||
      Number(data.appInfo.creation_type) === 2
        ? store.isSafari
          ? 'isSafariClass'
          : 'code'
        : ''
    "
  >
    <div class="down" @click="data.tutorial = !data.tutorial">
      <span>展开</span><van-icon name="arrow-down" />
    </div>
    <div
      class="generate"
      v-if="store.generate && Number(data.appInfo.creation_type) !== 2"
    >
      <div class="header">
        <img class="avatar" :src="data.appInfo.app_dialogue_avatar" alt="" />
        <div class="intro">{{ data.appInfo.intro }}</div>
      </div>
      <div class="centen">
        <div class="title">选择模版</div>
        <div class="styleList">
          <div class="tabs">
            <div
              class="item"
              :class="
                store.quitStyleTabs === tabs.opt_style ? 'quitTabsName' : ''
              "
              v-for="tabs in store.styleList"
              :key="tabs.id"
            >
              <div
                class="tabsName"
                @click="store.setQuitStyleTabs(tabs.opt_style)"
              >
                {{ tabs.opt_zh_name }}
              </div>
            </div>
          </div>
          <div v-for="tabs in store.styleList" :key="tabs.id">
            <div
              class="tabsCenten"
              :style="
                store.quitStyleTabs === 'style'
                  ? 'grid-template-columns: 1fr 1fr 1fr 1fr;'
                  : ''
              "
              :class="
                store.quitStyleTabs !== 'style'
                  ? store.isSafari
                    ? 'iosClass gar8'
                    : 'gar8'
                  : store.isSafari
                  ? 'iosClass'
                  : ''
              "
              v-if="store.quitStyleTabs === tabs.opt_style"
            >
              <div
                :class="store.quitStyleTabs === 'style' ? '' : 'item'"
                v-for="item in tabs.list"
                :key="item.id"
              >
                <div
                  @click="store.setQuitStyle(item)"
                  :class="{
                    quitStyleClass:
                      data.getStyleFLag(item.id) && !item.show_icon,
                    StyleItemClass: item.show_icon,
                    scalingItemClass: !item.show_icon,
                  }"
                >
                  <div
                    class="box"
                    v-if="store.quitStyleTabs === 'scaling'"
                    :style="data.getStyle(item.opt_zh_name)"
                  ></div>
                  <img
                    v-if="item.show_icon"
                    :src="item.show_icon"
                    alt=""
                    :class="data.getStyleFLag(item.id) ? 'quitStyleClass' : ''"
                  />
                  <div class="itemName">{{ item.opt_zh_name }}</div>
                </div>
                <!-- <div
                  v-else
                  class="StyleItemClass"
                  @click="store.setQuitStyle(item)"
                >
                  <img
                    :src="item.show_icon"
                    alt=""
                    :class="data.getStyleFLag(item.id) ? 'quitStyleClass' : ''"
                  />
                  <div class="itemName">{{ item.opt_zh_name }}</div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="bottomBtn">
          <div
            class="options"
            @click="
              data.setShow = true;
              data.tutorial = false;
            "
          >
            <div class="left">高级选项</div>
            <div class="right">
              绘画描述词/参照图片等<van-icon name="arrow" />
            </div>
          </div>
          <div class="clearBtn">
            <div class="btn" @click="data.startCreate">
              开始创作<span
                >({{
                  parseInt(data.appInfo.petal_price) +
                  "花瓣/会员" +
                  parseInt(data.appInfo.member_petal_price) +
                  "花瓣"
                }})</span
              >
            </div>
          </div>
          <div class="historyBtn">
            <span @click="data.historyRecord">历史创作记录</span>
          </div>
        </div>
      </div>
    </div>
    <div
      class="main"
      v-else
      :class="
        Number(data.appInfo.creation_type) === 2 ? '' : 'historyMainClass'
      "
    >
      <van-pull-refresh
        ref="imgMainRef"
        v-model="data.isLoading"
        :head-height="40"
        @refresh="data.onRefresh"
      >
        <template #pulling>
          <div class="refreshText">下拉加载历史记录(仅支持7天内)</div>
        </template>
        <template #loosing>
          <div class="refreshText">下拉加载历史记录(仅支持7天内)</div>
        </template>
        <template #success>
          <div class="refreshText">{{ data.succesText }}</div>
        </template>
        <div class="sortItem" v-for="item in data.list" :key="item.updated_at">
          <div class="item" v-if="item.message_type === 1">
            <!-- 人提问 -->
            <div class="header">
              <img
                style=" border-radius: 50%;"
                v-if="data.userInfo && data.userInfo.avatar"
                :src="data.userInfo.avatar"
                alt=""
              />
              <img v-else :src="data.appInfo.app_dialogue_avatar" alt="" />
            </div>
            <div class="text">
              <div v-if="data.resolution(item.image_attachments.gen.gen).text">
                {{ data.resolution(item.image_attachments.gen.gen).text }}
              </div>
              <div
                v-if="
                  !item.image_attachments.gen.orgin_image &&
                  data.resolution(item.image_attachments.gen.gen).img
                "
              >
                <img
                  :src="data.resolution(item.image_attachments.gen.gen).img"
                  alt=""
                />
              </div>
              <div v-if="item.image_attachments.gen.orgin_image">
                <img :src="item.image_attachments.gen.orgin_image" alt="" />
              </div>
              <span
                v-for="(type, index) in item.image_attachments.gen.gen_split"
                :key="index"
              >
                {{ type }}
              </span>
              <div
                class="editBtn"
                v-if="
                  data.editFlage &&
                  !item.image_attachments.gen.gen_split.some(
                    (item) => item === '2倍高清'
                  )
                "
                @click="data.isVisibleFunction(item)"
              >
                <img src="@/assets/editText.png" alt="" />
                修改
              </div>
            </div>
          </div>
          <div class="answer" v-if="item.message_type === 2">
            <div class="item AIItem">
              <div class="header">
                <img :src="data.appInfo.app_dialogue_avatar" alt="" />
              </div>
              <div
                class="text"
                v-if="
                  item.image_status !== 0 &&
                  item.image_status !== 1 &&
                  item.image_status !== 5
                "
              >
                <div class="title">
                  {{ data.getStatus(item.image_status) }}
                  。智能创作有一定随机性，可以重复创作从而得到满意的作品。
                </div>
                <div
                  :class="'swiper-container imgSwiper' + item.chat_no"
                  v-if="
                    item.image_attachments &&
                    item.image_attachments.images.crops.length > 0
                  "
                >
                  <!-- Swiper slide 列表 -->
                  <div class="swiper-wrapper">
                    <!-- Slide -->
                    <div class="swiper-slide">
                      <img
                        @click="
                          data.bigImg(item.image_attachments.images, 'index')
                        "
                        :src="item.image_attachments.images.main_url"
                      />
                    </div>
                    <div
                      class="swiper-slide"
                      v-for="(img, index) in item.image_attachments.images
                        .crops"
                      :key="img"
                    >
                      <img
                        @click="
                          data.bigImg(item.image_attachments.images, index)
                        "
                        :src="img"
                      />
                    </div>
                    <!-- ...其他 Slide -->
                  </div>
                  <!-- Swiper 分页器 -->
                  <div class="swiper-pagination"></div>
                </div>
                <div
                  v-else
                  class="noeImg"
                  @click="
                    data.bigImg(
                      item.image_attachments.images.main_url,
                      'noeImg'
                    )
                  "
                >
                  <img :src="item.image_attachments.images.main_url" />
                </div>
              </div>
              <div v-if="item.image_status === 5" class="text">
                <div class="title">创作失败</div>
              </div>
              <div
                v-if="item.image_status === 0 || item.image_status === 1"
                class="text"
              >
                <div>
                  {{ data.getStatus(item.image_status) }}，预计需要{{
                    data.userInfo.member_level === 1 ? "120-180秒" : "60-120秒"
                  }}，请耐心等候...
                </div>
                <div>
                  <van-progress
                    :percentage="parseInt(data.progress)"
                    stroke-width="10"
                  />
                </div>
                <div class="lodaing">
                  <div class="loadingio-spinner-spin-bjdjzuypnkp">
                    <div class="ldio-6q3tsw3w7jf">
                      <div><div></div></div>
                      <div><div></div></div>
                      <div><div></div></div>
                      <div><div></div></div>
                      <div><div></div></div>
                      <div><div></div></div>
                      <div><div></div></div>
                      <div><div></div></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="quicken"
              @click="data.goPay"
              v-if="item.image_status === 0 || item.image_status === 1"
            >
              <img src="@/assets/quicken.png" alt="" />
              {{
                data.userInfo.member_level === 1
                  ? "开通会员加速通道"
                  : "已开启会员加速通道"
              }}
            </div>
            <div
              class="btnList"
              v-if="
                item.image_status !== 0 &&
                item.image_status !== 1 &&
                item.image_status !== 5
              "
              :class="
                Number(data.appInfo.creation_type) === 2 &&
                !data.localStorageFlage
                  ? 'p-b-120'
                  : ''
              "
            >
              <span class="editBtn" @click="data.laud">
                <img :src="data.laudFlage ? resLaud : laud" alt="" />
                点赞
              </span>
              <span class="editBtn" @click="data.shares(item)">
                <img src="@/assets/share.png" alt="" />
                分享
              </span>
              <span class="editBtn" @click="data.download(item)">
                <img src="@/assets/download.png" alt="" />
                下载
              </span>
              <span
                class="editBtn"
                v-if="
                  !item.image_attachments.gen.gen_split.some(
                    (item) => item === '2倍高清'
                  )
                "
                @click="data.isVisibleFunction(item, 'clear')"
              >
                <img src="@/assets/renovate.png" alt="" />
                重新创作
              </span>
            </div>
            <!-- Number(data.appInfo.creation_type) === 2? 'm-b-60' : '' -->
            <!-- <span
              class="laud"
              v-if="
                index === data.list.length - 1 &&
                item.image_status !== 0 &&
                item.image_status !== 1 &&
                item.image_status !== 5 &&
                data.localStorageFlage
              "
              :class="!item.image_attachments.gen.gen_split.some(item=> item === '2倍高清')?Number(data.appInfo.creation_type) === 2? 'm-b-60' : '' :Number(data.appInfo.creation_type) === 2? 'm-b-60 lauds' : 'lauds'"
              >对创作成果首次点赞或分享可得5花瓣/次</span
            >  -->
            <div
              class="multiple"
              @click="data.amplify(item)"
              v-if="
                Number(data.appInfo.creation_type) !== 2 &&
                data.activeIndexList[item.chat_no] !== 0 &&
                item.image_status !== 0 &&
                item.image_status !== 1 &&
                item.image_status !== 5 &&
                item.image_attachments.images.crops.length !== 0
              "
            >
              <img src="@/assets/big.png" alt="" />
              <span>2倍高清放大(5花瓣)</span>
            </div>
            <!-- ai回答 -->
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
  <van-popup
    class="imgPopup"
    v-model:show="data.tutorial"
    position="top"
    :overlay="false"
  >
    <!-- <div class="item">
      <div class="active">
        <img  v-if="data.userInfo && data.userInfo.avatar" :src="data.userInfo.avatar" alt="">
        <img v-else src="@/assets/userActive.png" alt="">
      </div>
      <div class="text">
        {{props.intro}}
      </div>
      
    </div> -->
    <div class="header" v-if="data.appInfo.scenario_case.data">
      <div class="title">场景案例</div>
      <div class="btn" @click="data.goNewPage">
        更多教程<img src="@/assets/right.png" alt="" />
      </div>
    </div>
    <div class="list">
      <div
        class="card"
        v-for="(item, index) in data.appInfo.scenario_case.data"
        :key="item"
      >
        <img :src="item" alt="" @click="data.quitImg(index)" />
      </div>
    </div>
    <div class="cardBtn" v-if="data.appInfo.scenario_case.data">
      点击图片放大
    </div>
    <div class="up" @click="data.tutorial = !data.tutorial">
      <span>收起</span><van-icon name="arrow-up" />
    </div>
  </van-popup>
  <van-overlay :show="data.show" z-index="26999">
    <div class="overlay" @click="data.show = false">
      <van-swipe :initial-swipe="data.initialSwipe" :show-indicators="false">
        <van-swipe-item class="item" v-for="image in data.imgList" :key="image">
          <img
            style="width: 100%"
            :src="
              data.flage
                ? image +
                  '?x-oss-process=image/resize,w_500/watermark,type_d3F5LXplbmhlaQ,size_20,text_6Iqx6ZuGQUnnsr7ngbUK,color_8368FC,t_100,g_se,x_10,y_10'
                : image
            "
          />
        </van-swipe-item>
      </van-swipe>
    </div>
  </van-overlay>
  <van-popup
    class="sharesPopup"
    :show="data.sharesShow"
    round
    :closed="(data.sharsUrl = '')"
  >
    <div class="shares">
      <div class="cavers" ref="shares">
        <div class="header">
          {{ data.appInfo.name }}
        </div>
        <div class="tip">
          {{ data.appInfo.desc }}
        </div>
        <div class="sharsImg"><img :src="data.sharsImg" alt="" /></div>
        <div class="qrcode">
          <div>
            <div class="title">花集AI</div>
            <div class="samll">让天下没有难用的AI</div>
          </div>
          <div class="code">
            <img :src="data.qrcode" alt="" />
          </div>
        </div>
      </div>
      <div class="bottom">
        <div @click="data.copy"         
        class="copyBtn"
        :data-clipboard-text="data.shareImgUrl">
          <img src="@/assets/imgInfolink.png" alt="" />复制链接
        </div>
        <div @click="data.saveImg" :style="data.sharsUrl ? '' : 'opacity:.8'">
          <img src="@/assets/saveIcon.png" alt="" />保存图片
        </div>
      </div>
      <div class="close" @click="data.sharesShow = false">
        <img src="@/assets/sharesCloes.png" alt="" />
      </div>
    </div>
  </van-popup>
  <van-overlay :show="data.isVisible">
    <div class="confirm-box">
      <div class="confirm-message">
        重新创作需要{{ Number(data.appInfo.petal_price) }}花瓣
      </div>
      <div class="confirm-buttons">
        <div @click="data.handleConfirm()">确认</div>
        <div @click="data.isVisible = false">取消</div>
      </div>
    </div>
  </van-overlay>
  <van-popup
    class="setPop"
    v-model:show="data.setShow"
    position="bottom"
    :style="{ height: '90%' }"
  >
    <div class="header">
      高级选项
      <img
        src="@/assets/popClose.png"
        class="popCloseClass"
        alt=""
        @click="data.setShow = false"
      />
    </div>
    <div class="tip">
      作品公开<span>(生成后自动投稿至图库，获得推荐可返花瓣)</span>
    </div>
    <div class="acquiesce" @click="data.vipChange">
      默认全部不公开
      <div
        class="vip"
        :style="
          data.userInfo && data.userInfo.member_level === 1
            ? 'background: linear-gradient(119deg, #CCCCCC 0%, #999999 100%);color: #FFFFFF;'
            : ''
        "
      >
        VIP
      </div>
      <van-switch
        v-model="data.vipChecked"
        active-color="#8368FC"
        size="22"
        @change="data.change"
        :disabled="
          (data.userInfo && data.userInfo.member_level === 1) || !data.userInfo
        "
      />
    </div>
    <van-radio-group v-model="data.checked">
      <van-radio name="1">
        本次公开
        <template #icon="props">
          <img
            class="img-icon"
            :src="props.checked ? activeIcon : inactiveIcon"
          />
        </template>
      </van-radio>
      <van-radio name="0">
        本次不公开
        <template #icon="props">
          <img
            class="img-icon"
            :src="props.checked ? activeIcon : inactiveIcon"
          />
        </template>
      </van-radio>
    </van-radio-group>
    <div class="desc">
      <div class="title">绘画描述(选填)</div>
      <div class="input">
        <!-- :maxlength="data.appInfo.input_box_max_character" -->
        <van-cell-group inset>
          <van-field
            v-model="data.prompt"
            rows="1"
            :maxlength="data.appInfo.input_box_max_character"
            autosize
            type="textarea"
            :placeholder="data.appInfo.input_box_placeholder"
          />
        </van-cell-group>
        <div class="sort">
          <div>
            {{
              data.prompt.length + "/" + data.appInfo.input_box_max_character
            }}
          </div>
          <img
            @click="data.yuyinShow = true"
            src="@/assets/soundIcon.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="imgList">
      <div class="title">参考图片(选填)</div>
      <div class="itemList">
        <div class="item" v-for="(item, index) in data.fileList" :key="index">
          <img :src="item" />
          <van-icon name="cross" @click="data.fileList = []" />
        </div>
        <van-uploader :after-read="afterRead">
          <img class="uploaderClass" src="@/assets/addImg.png" alt="" />
        </van-uploader>
      </div>
    </div>
    <div class="styleList">
      <div class="tabs">
        <div
          class="item"
          :class="store.quitStyleTabs === tabs.opt_style ? 'quitTabsName' : ''"
          v-for="tabs in store.styleList"
          :key="tabs.id"
        >
          <div class="tabsName" @click="store.setQuitStyleTabs(tabs.opt_style)">
            {{ tabs.opt_zh_name }}
          </div>
        </div>
      </div>
      <div v-for="tabs in store.styleList" :key="tabs.id">
        <div
          class="tabsCenten"
          :style="
            store.quitStyleTabs === 'style'
              ? 'grid-template-columns: 1fr 1fr 1fr 1fr;'
              : ''
          "
          :class="
            store.quitStyleTabs !== 'style'
              ? store.isSafari
                ? 'iosClass gar8'
                : 'gar8'
              : store.isSafari
              ? 'iosClass'
              : ''
          "
          v-if="store.quitStyleTabs === tabs.opt_style"
        >
          <div
            :class="store.quitStyleTabs === 'style' ? '' : 'item'"
            v-for="item in tabs.list"
            :key="item.id"
          >
            <div
              @click="store.setQuitStyle(item)"
              :class="{
                quitStyleClass: data.getStyleFLag(item.id) && !item.show_icon,
                StyleItemClass: item.show_icon,
                scalingItemClass: !item.show_icon,
              }"
            >
              <div
                class="box"
                v-if="store.quitStyleTabs === 'scaling'"
                :class="data.getStyleFLag(item.id) ? 'quitBoxClass' : ''"
                :style="data.getStyle(item.opt_zh_name)"
              ></div>
              <img
                v-if="item.show_icon"
                :src="item.show_icon"
                alt=""
                :class="data.getStyleFLag(item.id) ? 'quitStyleClass' : ''"
              />
              <div class="itemName">{{ item.opt_zh_name }}</div>
            </div>
            <!-- <div
              v-else
              class="StyleItemClass"
              @click="store.setQuitStyle(item)"
            >
              <img
                :src="item.show_icon"
                alt=""
                :class="data.getStyleFLag(item.id) ? 'quitStyleClass' : ''"
              />
              <div class="itemName">{{ item.opt_zh_name }}</div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="clearBtn">
        <div class="btn" @click="data.startCreate">
          开始创作<span
            >({{
              parseInt(data.appInfo.petal_price) +
              "花瓣/会员" +
              parseInt(data.appInfo.member_petal_price) +
              "花瓣"
            }})</span
          >
        </div>
      </div>
    </div>
  </van-popup>
  <van-popup
    v-model:show="data.yuyinShow"
    @close="data.close"
    position="bottom"
    class="yuyin"
  >
    <div class="main">
      <div class="header">我在听，请说话</div>
      <img
        src="@/assets/homeClose.png"
        @click="data.yuyinShow = false"
        class="close"
      />
      <div class="time">{{ data.time + "''" }}</div>
      <Suspense>
        <template #default>
          <dictaticon
            @start="data.start"
            @end="data.end"
            @changeStr="data.getText"
          />
        </template>
      </Suspense>
      <div class="text">摁住说话</div>
    </div>
  </van-popup>
  <div class="m-share" id="share"></div>
</template>

<script setup>
import {
  ref,
  onBeforeUnmount,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  watchEffect,
  computed,
  nextTick,
} from "vue";
import { useCounterStore } from "@/store";
import { useRoute, useRouter } from "vue-router";
import {
  generate,
  imgHistory,
  undateImg,
  editUserStatus,
  ampfilyImg,
} from "@/api/img";
import Swiper from "swiper";
import { clickLike, Appshare } from "@/api/text";
import resLaud from "@/assets/resLaud.png";
import laud from "@/assets/laud.png";
import share from "m-share";
import html2canvas from "html2canvas";
import domtoimage from "dom-to-image";
import { userInfo } from "@/api/login";
import { get } from "@/ulits/http";
import { showSuccessToast } from "vant";
import surres from "@/assets/surres.png";
import { showConfirmDialog } from "vant";
import activeIcon from "@/assets/true.png";
import dictaticon from "@/components/version/dictation.vue";
import inactiveIcon from "@/assets/false.png";
import { getToken } from "@/ulits/auth";
import { showToast } from "vant";
import { showNotify } from "vant";
import ClipboardJS from "clipboard";
import { teamCode } from "@/api/invite";
const QRCode = require("qrcode");
const emit = defineEmits(["imgEdit"]);
/**
 * 仓库
 */
const store = useCounterStore();
/**
 * 路由对象
 */
const route = useRoute();
/**
 * 路由实例
 */
const router = useRouter();
//console.log('1-开始创建组件-setup')
/**
 * 数据部分
 */
const data = reactive({});
const imgMainRef = ref(null);
data.shareImgUrl = '';
data.prompt = "";
data.initialSwipe = 0;
data.isVisible = false;
data.yuyinShow = false;
data.setShow = false;
data.twoFlag = true;
data.time = 0;
data.item = {};
data.isVisibleFunction = (e) => {
  showConfirmDialog({
    title: "提示",
    message:
      "重新创作需要" +
      Number(data.appInfo.petal_price) +
      "花瓣,需要重新创作吗？",
  }).then(() => {
    if (data.appInfo.creation_type === 2) {
      data.edit(e);
    } else {
      store.setGenerate(true);
      store.copywritingTrue();
      const parmas = data.resolution(e.image_attachments.gen.gen);
      if (parmas.img) {
        data.fileList[0] = parmas.img;
      }
      if (parmas.text) {
        data.prompt = parmas.text === "无题" ? "" : parmas.text;
      }
      const arr = e.image_attachments.gen.payload_json.filter((item) => {
        item.id = item.value;
        return delete item.value;
      });
      store.setEditData(arr);
    }
  });
};
data.handleConfirm = () => {};
data.progress = 0;
data.localStorageFlage = localStorage.getItem("laudFlae") ? false : true;
data.qrcode = "";

data.goNewPage = () => {
  window.open("https://huajiwang.feishu.cn/wiki/BGN5wBnW9ibJ7GkiF6JctJQDnAf");
};
share.init({
  link: "http://www.qq.com", // 网址，默认使用window.location.href
  title: "标题", // 标题，默认读取document.title
  desc: "分享描述", // 描述, 默认读取<meta name="description" content="desc" />
  imgUrl: "http://backtonature.github.io/project/m-share/demo1.png", // 图片, 默认取网页中第一个img标签
  types: ["wx", "wxline", "qq", "qzone", "sina"], // 启用的社交分享,默认为全部启用
  infoMap: {
    // 针对不同平台设定不同分享内容
    wx: {
      link: 11, // 覆盖分享到微信的链接
      title: 11, // 覆盖分享到微信的标题
      desc: 11, // 覆盖分享到微信的标题
      imgUrl: 11, // 覆盖分享到微信的图片链接
    },
  },
  fnDoShare(type) {
    // 执行分享的回调，type为'wx', 'wxline', 'qq', 'qzone', 'sina'
  },
});

const shares = ref(null);
data.sharsUrl = "";
data.sharsImg = "";
data.fileList = [];
data.sharesShow = false;
data.activeIndex = 0;
data.activeIndexList = {};
data.laudFlage = false;
data.isLoading = false;
data.onRefresh = () => {
  data.getHistory(2);
};
data.list = [];
data.imgList = [];
data.userInfo = JSON.parse(localStorage.getItem("userInfo"));
data.vipChecked =
  data.userInfo && data.userInfo.member_level === 1
    ? false
    : data.userInfo && data.userInfo.is_info_public === 2
    ? true
    : false;
data.checked = data.userInfo && data.userInfo.member_level === 1 ? "1" : "0";
data.page = 1;
data.imgtime = null;
const props = defineProps({
  intro: String,
  params: Object,
});
data.succesText = "刷新成功";
data.show = false;
data.tutorial = false;
data.editFlage = false;
// 获取配置详情
data.quitImg = (index) => {
  data.imgList = data.appInfo.scenario_case.data;
  data.initialSwipe = index;
  data.show = true;
};

data.shareWx = () => {
  share.to("wx");
  Appshare({ app_id: data.appInfo.id }).then((res) => {
    if (res.code === 200) {
      localStorage.setItem("laudFlae", false);
      showSuccessToast({
        message: res.message,
        icon: surres,
      });
    }
  });
};

data.saveImg = () => {
  if (data.sharsUrl) {
    let a = document.createElement("a");
    a.href = data.sharsUrl;
    a.download = "AI";
    a.click();
  } else {
    showToast("正在生成图片");
  }
};

data.copy = async (e) => {
  const clipboard = new ClipboardJS(".copyBtn");
  clipboard.on("success", () => {
    showNotify({ type: "success", message: "复制成功" });
  });
  clipboard.on("error", () => {
    showNotify({ type: "danger", message: "复制失败" });
  });
};

// 上传图片
const afterRead = (file) => {
  undateImg(file.file).then((res) => {
    data.fileList[0] = res.url;
  });
};

data.getStatus = (e) => {
  let text = "";
  switch (e) {
    case 0:
      text = "正在努力创作中";
      break;
    case 1:
      text = "正在努力创作中";
      break;
    case 2:
      text = "创作完成";
      break;
    case 3:
      text = "审核拒绝";
      break;
    case 4:
      text = "取消创作";
      break;
    case 5:
      text = "生成失败";
      break;
  }
  return text;
};

data.getHistory = (e) => {
  data.appInfo = JSON.parse(localStorage.getItem("appInfo"));
  imgHistory({
    app_id: data.appInfo.id,
    page_size: e,
    page: data.page,
  }).then((res) => {
    if (res.code === 200) {
      if (res.data.total === 0 && data.succesText !== "暂无更多数据") {
        data.tutorial = true;
      }
      if (res.data.items.length > 0) {
        data.page = data.page + 1;
        data.succesText = "刷新成功";
      } else {
        data.succesText = "暂无更多数据";
      }
      data.isLoading = false;
      data.list.unshift(...res.data.items.reverse());
      const flag = res.data.items.some(
        (e) =>
          e.message_type === 2 && e.image_status !== 0 && e.image_status !== 1
      );
      if (flag) {
        data.editFlage = true;
        const id = res.data.items[1].chat_no;
        data.activeIndexList[id] = 0;
        nextTick(() => {
          const myswiper = new Swiper(
            `.imgSwiper${res.data.items[1].chat_no}`,
            {
              // 开启分页器
              slidesPerView: "auto",
              centeredSlides: true,
              spaceBetween: 10,
              pagination: {
                el: ".swiper-pagination",
                clickable: true,
                // 自定义分页器内容
                renderBullet: function (index, className) {
                  // 这里可以根据自己的需要，返回任意的内容。下面是一个例子：
                  if (index === 0) {
                    return (
                      '<span class="' + className + '">滑动查看单张</span>'
                    );
                  } else {
                    return (
                      '<span class="' + className + '">' + index + "</span>"
                    );
                  }
                },
              },
            }
          );
          myswiper.on("slideChange", function () {
            data.activeIndexList[id] = this.activeIndex;
          });
        });
      } else {
        if (res.data.items.length > 0) {
          data.progress = 0;
          // const increment = 1.65; // 在30秒内逐渐加到99%需要的增量
          // const intervalId = setInterval(() => {
          //   data.progress += increment;
          //   if (Math.floor(data.progress) >= 99) {
          //     clearInterval(intervalId);
          //   }
          // }, 500); // 每10毫秒更新一次进度
          let maxProgress = 99;
          // 计算每次增加进度的时间间隔
          let intervalTime = 30000 / (maxProgress - data.progress);
          let intervalId = setInterval(() => {
            if (data.progress >= maxProgress) {
              clearInterval(intervalId); // 当进度到达或超过99时, 清除定时器
            } else {
              data.progress++;
              // 更新进度条
            }
          }, intervalTime);
          data.imgtime = setInterval(() => {
            data.add();
          }, 10000);
        }
      }
    }
  });
};

data.add = () => {
  imgHistory({
    app_id: data.appInfo.id,
    page_size: 2,
    page: 1,
  }).then((res) => {
    if (res.code === 200) {
      if (res.data.items.length === 0) {
        clearInterval(data.imgtime);
      }
      res.data.items.forEach((e) => {
        if (
          e.message_type === 2 &&
          e.image_status !== 0 &&
          e.image_status !== 1
        ) {
          data.progress = 100;
          setTimeout(() => {
            data.editFlage = true;
            data.list[data.list.length - 1] = e;
            const id = res.data.items[1].chat_no;
            data.activeIndexList[id] = 0;
            nextTick(() => {
              // data.activeIndex = 0
              let myswiper = new Swiper(
                `.imgSwiper${res.data.items[1].chat_no}`,
                {
                  // 开启分页器
                  slidesPerView: "auto",
                  centeredSlides: true,
                  spaceBetween: 10,
                  pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    // 自定义分页器内容
                    renderBullet: function (index, className) {
                      // 这里可以根据自己的需要，返回任意的内容。下面是一个例子：
                      if (index === 0) {
                        return (
                          '<span class="' + className + '">滑动查看单张</span>'
                        );
                      } else {
                        return (
                          '<span class="' + className + '">' + index + "</span>"
                        );
                      }
                    },
                  },
                  on: {
                    slideChange: function () {
                      data.activeIndexList[id] = this.activeIndex;
                    },
                  },
                }
              );
            });
            clearInterval(data.imgtime);
          }, 1000);
        }
      });
    }
  });
};

data.setGenerate = () => {
  generate({ ...store.imgParmas }).then((res) => {
    if (res.code === 200) {
      data.setShow = false;
      store.setGenerate(false);
      data.clearParmas();
      data.swiperInit();
      data.progress = 0;
      // const increment = 1.65; // 在30秒内逐渐加到99%需要的增量
      // const intervalId = setInterval(() => {
      //   if (data.progress + increment >= 99) {
      //     clearInterval(intervalId);
      //     data.progress = 99;
      //   } else {
      //     data.progress += increment;
      //   }
      // }, 500); // 每10毫秒更新一次进度
      let maxProgress = 99;
      // 计算每次增加进度的时间间隔
      let intervalTime = 30000 / (maxProgress - data.progress);
      let intervalId = setInterval(() => {
        if (data.progress >= maxProgress) {
          clearInterval(intervalId); // 当进度到达或超过99时, 清除定时器
        } else {
          data.progress++;
          // 更新进度条
        }
      }, intervalTime);
      data.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      userInfo({ user_id: data.userInfo.id }).then((user) => {
        if (user.code === 200) {
          store.setUserInfo(user.data);
          localStorage.setItem("userInfo", JSON.stringify(user.data));
        }
      });
      data.list.push(
        {
          message_type: 1,
          image_attachments: {
            gen: {
              gen:
                store.imgParmas.image_url +
                " " +
                (store.imgParmas.prompt ? store.imgParmas.prompt : "无题"),
              gen_split: store.imgParmas.span,
              payload_json: JSON.parse(store.imgParmas.payload_json),
            },
          },
        },
        {
          message_type: 2,
          image_status: 0,
        }
      );
      nextTick(() => {
        const height = imgMainRef.value.$el.clientHeight;
        imgMainRef.value.$el.scrollTop =
          imgMainRef.value.$el.scrollHeight - height;
      });
      document.documentElement.style.setProperty("--textHeader", `${0}px`);
      store.copywritingFalse();
      data.page = data.page + 1;
      data.imgtime = setInterval(() => {
        data.add();
      }, 10000);
    }
  });
};

data.download = (e) => {
  let url;
  if (data.activeIndexList[e.chat_no] === 0) {
    url = e.image_attachments.images.main_url;
  } else {
    url = e.image_attachments.images.crops[data.activeIndexList[e.chat_no] - 1];
  }
  let a = document.createElement("a");
  a.href = url.split("?")[0];
  a.download = "AI图片";
  a.click();
};

data.shares = (e) => {
  teamCode().then((res) => {
    if (res.code === 200) {
      let params = new URL(document.location).searchParams;
      let param1 = params.get("id");
      data.shareImgUrl = param1
        ? location.href + "&invite_code=" + res.data.code
        : location.href +
          "?id=" +
          data.appInfo.id +
          "&invite_code=" +
          res.data.code;
      QRCode.toDataURL(data.shareImgUrl).then((res) => {
        data.qrcode = res;
        let url;
        if (data.activeIndexList[e.chat_no] === 0) {
          url = e.image_attachments.images.main_url;
        } else {
          url =
            e.image_attachments.images.crops[
              data.activeIndexList[e.chat_no] - 1
            ];
        }
        data.sharsImg = url;
        data.sharesShow = true;
        setTimeout(() => {
          html2canvas(shares.value, {
            // scale: 1,
            allowTaint: true,
            useCORS: true,
          }).then((canvas) => {
            const sharsUrl = canvas.toDataURL("image/png");
            undateImg(data.base64ToFile(sharsUrl, "newfile.png")).then(
              (res) => {
                data.sharsUrl = res.url;
                if (/android/i.test(navigator.userAgent)) {
                  wx.onMenuShareAppMessage({
                    title: data.appInfo.name,
                    desc: data.appInfo.desc,
                    link: res.url,
                    imgUrl: res.url,
                  });
                }
                if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                  wx.updateAppMessageShareData({
                    title: data.appInfo.name,
                    desc: data.appInfo.desc,
                    link: res.url,
                    imgUrl: res.url,
                  });
                }
              }
            );
          });
        });
      });
    }
  });
};

data.base64ToFile = (base64, fileName) => {
  const arr = base64.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], fileName, { type: mime });
};

data.edit = (e) => {
  data.list.filter((i, index) => {
    if ((index - 2 === 0 || index === 0) && i.message_type === 1) {
      let params = {
        gen: i.image_attachments.gen.gen,
        payload_json: i.image_attachments.gen.payload_json,
      };
      emit("imgEdit", params);
      data.isVisible = false;
    }
  });
};

data.laud = () => {
  if (data.laudFlage) {
    data.laudFlage = false;
  } else {
    clickLike({ app_id: data.appInfo.id }).then((res) => {
      if (res.code === 200) {
        localStorage.setItem("laudFlae", false);
        data.localStorageFlage = false;
        data.laudFlage = true;
        showSuccessToast({
          message: res.message,
          icon: surres,
        });
      }
    });
  }
};

// 拆分
data.resolution = (e) => {
  let str = new RegExp("http");
  let params = {};
  if (str.test(e)) {
    params.img = e.split(" ")[0];
    params.text = e.substring(params.img.length);
  } else {
    if (str.test(e)) {
      params.img = e;
      params.text = "无题";
    } else {
      params.text = e;
    }
  }

  return params;
};

data.editBtn = (e) => {
  emit("imgEdit", e.image_attachments.gen);
  store.copywritingTrue();
};

data.goPay = () => {
  if (data.userInfo.member_level === 2) {
    return;
  }
  localStorage.setItem("type", "1");
  router.push({
    name: "template",
    query: {
      title: "会员充值",
    },
  });
};

data.bigImg = (e, index) => {
  data.imgList = [];
  if (index === "index") {
    data.initialSwipe = 0;
    data.imgList.push(e.main_url, ...e.crops);
  } else if (index === "noeImg") {
    data.imgList.push(e);
  } else {
    data.initialSwipe = index + 1;
    data.imgList.push(e.main_url, ...e.crops);
  }
  data.show = true;
};

data.getStyle = (e) => {
  let num = Number(e.split(":")[0]) + Number(e.split(":")[1]);
  let width =
    (((180 / num) * Number(e.split(":")[0])) / window.innerWidth) * 100;
  let height =
    (((180 / num) * Number(e.split(":")[1])) / window.innerWidth) * 100;
  let text = "width:" + width + "px;height:" + height + "px;";
  return text;
};

data.getStyleFLag = computed(() => (id) => {
  let john = store.appStyleList.find(
    (item) =>
      item.name === store.quitStyleTabs && Number(item.id) === Number(id)
  );
  if (john) {
    return true;
  } else {
    return false;
  }
});

data.change = (e) => {
  if (e) {
    data.checked = "0";
  } else {
    data.checked = "1";
  }
  editUserStatus({
    user_id: data.userInfo.id,
    status: e ? 2 : 1,
  }).then((res) => {
    userInfo({ user_id: data.userInfo.id }).then((user) => {
      if (user.code === 200) {
        store.setUserInfo(user.data);
        localStorage.setItem("userInfo", JSON.stringify(user.data));
      }
    });
  });
};

data.start = (e) => {
  data.time = e;
};
data.end = (e) => {
  data.time = 0;
};

data.getText = (e) => {
  data.prompt = "";
  data.prompt += e;
};

data.startCreate = () => {
  const styleList = store.appStyleList.map((item) => {
    return {
      ...item, // 这一句会展开原有的所有属性
      value: item.id, // 添加新的 value 属性，等于原来的 id 属性的值
    };
  });
  let parmas = {
    app_id: data.appInfo.id,
    payload_json: JSON.stringify(styleList),
    prompt: data.prompt,
    is_open: data.checked,
    image_url: data.fileList.length > 0 ? data.fileList[0] : "",
    span: [],
  };
  store.styleList.filter((j) => {
    styleList.filter((i) => {
      if (i.name === j.opt_style) {
        parmas.span.push(j.opt_zh_name + "  " + i.opt_zh_name);
      }
    });
  });
  store.setImgParmas(parmas);
  data.setGenerate();
};

data.clearParmas = () => {
  data.prompt = "";
  data.fileList = [];
  store.clearAppStyleList();
};

data.historyRecord = () => {
  data.list = [];
  data.page = 1;
  data.getHistory(2);
  store.copywritingFalse();
  store.setGenerate(false);
  data.swiperInit();
};

data.swiperInit = () => {
  nextTick(() => {
    data.myswiper = new Swiper(".imgSwiper", {
      // 开启分页器
      slidesPerView: "auto",
      centeredSlides: true,
      spaceBetween: 10,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        // 自定义分页器内容
        renderBullet: function (index, className) {
          // 这里可以根据自己的需要，返回任意的内容。下面是一个例子：
          if (index === 0) {
            return '<span class="' + className + '">滑动查看单张</span>';
          } else {
            return '<span class="' + className + '">' + index + "</span>";
          }
        },
      },
    });
    data.myswiper.on("slideChange", function () {
      data.activeIndex = this.activeIndex;
    });
  });
};

data.amplify = (e) => {
  if (!data.twoFlag) {
    return false;
  } else {
    data.twoFlag = false;
  }
  let parmas = {
    scaling: "2x",
    chat_no: e.chat_no,
    app_id: data.appInfo.id,
    index: data.activeIndexList[e.chat_no],
  };
  const arr = data.list.filter((item) => {
    return item.chat_no === e.chat_no && item.message_type === 2;
  });
  ampfilyImg(parmas)
    .then((res) => {
      if (res.code === 200) {
        arr[0].image_attachments.gen.gen_split.push("2倍高清");
        data.progress = 0;
        let maxProgress = 99;
        let intervalTime = 30000 / (maxProgress - data.progress);
        let intervalId = setInterval(() => {
          if (data.progress >= maxProgress) {
            clearInterval(intervalId);
          } else {
            data.progress++;
          }
        }, intervalTime);
        data.userInfo = JSON.parse(localStorage.getItem("userInfo"));
        userInfo({ user_id: data.userInfo.id }).then((user) => {
          if (user.code === 200) {
            store.setUserInfo(user.data);
            localStorage.setItem("userInfo", JSON.stringify(user.data));
          }
        });
        data.list.push(
          {
            message_type: 1,
            image_attachments: {
              gen: {
                gen: arr[0].image_attachments.gen.gen,
                gen_split: arr[0].image_attachments.gen.gen_split,
                payload_json: arr[0].image_attachments.gen.payload_json,
                orgin_image:
                  e.image_attachments.images.crops[
                    data.activeIndexList[e.chat_no] - 1
                  ],
              },
            },
          },
          {
            message_type: 2,
            image_status: 0,
          }
        );
        data.page = data.page + 1;
        data.imgtime = setInterval(() => {
          data.add();
        }, 10000);
      }
    })
    .finally(() => {
      data.twoFlag = true;
    });
};

onBeforeMount(() => {
  //console.log('2.组件挂载页面之前执行----onBeforeMount')
});
onMounted(() => {
  if (getToken() && data.userInfo) {
    setTimeout(()=>{
      data.getHistory(2);
    },1500)
  } else {
    data.tutorial = true;
  }
  //console.log('3.-组件挂载到页面之后执行-------onMounted')
});
watchEffect(() => {
  data.appInfo = JSON.parse(localStorage.getItem("appInfo"));
});

onBeforeUnmount(() => {
  clearInterval(data.imgtime);
});
// 使用toRefs解构
// let { } = { ...toRefs(data) }
defineExpose({
  ...toRefs(data),
});
</script>
<style lang="scss" scoped>
.isSafariClass {
  // height: calc(100vh - 720px - var(--textHeader)) !important;
  // height: 82% !important;
  // overflow: hidden !important;
  // overflow-y: auto !important;
}
.code {
  // height: calc(100vh - 560px - var(--textHeader)) !important;
}
.imageGeneration {
  // height: calc(100vh - 360px);
  flex-grow: 1;
  // overflow: hidden;
  // overflow-y: auto; /* 如果内容超出可视区，可滚动查看 */
  margin-top: 92px;
  // padding-bottom: 100px;
  .generate {
    background: #111525;
    .header {
      margin-top: 64px;
      display: flex;
      padding: 0 24px;
      height: 190px;
      overflow-y: auto;
      align-items: self-start;
      .avatar {
        width: 88px;
        height: 88px;
        margin-right: 16px;
      }
      .intro {
        background: #323647;
        border-radius: 24px;
        padding: 20px;
        width: 478px;
        color: #ffffff;
        font-size: 28px;
        font-weight: 300;
      }
    }
    .centen {
      color: #ffffff;
      margin-top: 32px;
      border-radius: 48px 48px 0px 0px;
      border-top: 1px solid #ffffff10;
      .title {
        color: #f7f5ff;
        font-size: 32px;
        padding: 0 24px;
        padding-top: 24px;
      }
      .styleList {
        padding: 0 24px;
        margin-top: 16px;
        color: #ffffff;
        font-size: 30px;
        .tabs {
          display: flex;
          white-space: nowrap;
          overflow-y: auto;
          padding-bottom: 10px;
          .item {
            margin-right: 48px;
          }
        }
        .tabs::-webkit-scrollbar {
          display: none;
        }
        .tabsName {
          position: relative;
        }
        .quitTabsName {
          position: relative;
        }
        .quitTabsName::after {
          content: "";
          background: #8368fc;
          border-radius: 30px;
          height: 4px;
          width: calc(100% - 20px);
          margin: 0 10px;
          left: 0;
          position: absolute;
          bottom: -5px;
        }
        .gar8 {
          grid-auto-rows: 80px !important;
          grid-gap: 48px !important;
        }
        .iosClass {
          height: calc(100vh - 1050px) !important;
        }
        .tabsCenten {
          height: calc(100vh - 970px);
          overflow: hidden;
          overflow-y: auto;
          margin-top: 24px;
          display: grid;
          grid-auto-rows: 160px;
          grid-template-columns: 1fr 1fr 1fr;
          grid-gap: 24px;
          .quitStyleClass {
            border: 4px solid #8368fc;
            box-sizing: border-box;
            color: #ffffff !important;
            background: #8368fc !important;
            .box {
              border-color: #ffffff !important;
            }
          }
          .item {
            .scalingItemClass {
              border: 2px solid #8368fcff;
              background: transparent;
              color: #8368fc;
              border-radius: 40px;
              height: 80px;
              display: flex;
              align-items: center;
              justify-content: center;
              .box {
                margin-right: 10px;
                border: 4px solid #8368fcff;
              }
            }
          }
          .StyleItemClass {
            position: relative;
            img {
              width: 100%;
              height: 100%;
              border-radius: 16px;
            }
            .itemName {
              position: absolute;
              bottom: 7px;
              width: 100%;
              background: #11152540;
              color: #f7f5ff;
              font-size: 24px;
              text-align: center;
              padding: 7px 0;
              border-radius: 0px 0px 16px 16px;
            }
          }
        }
        .tabsCenten::-webkit-scrollbar {
          display: none;
        }
      }
      .bottomBtn {
        position: absolute;
        bottom: 0;
        width: 100%;
        border-top: 1px solid#FFFFFF20;
        .options {
          display: flex;
          justify-content: space-between;
          padding: 29px 24px;
          background: #10152580;
          .left {
            font-size: 32px;
          }
          .right {
            font-size: 28px;
            color: #f7f5ff80;
          }
        }
      }
      .clearBtn,
      .historyBtn {
        background: #000000;
        text-align: center;
      }
      .clearBtn {
        padding-top: 24px;
        .btn {
          font-size: 32px;
          margin: 0 75px;
          padding: 21px 0;
          margin-top: 20px;
          background: #8368fc;
          border-radius: 49px;
          text-align: center;
          color: #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;
          span {
            font-size: 24px;
          }
        }
      }
      .historyBtn {
        padding-top: 14px;
        padding-bottom: 30px;
      }
    }
  }
}
.down {
  position: fixed;
  top: 112px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #272934;
  width: 100vw;
  height: 92px;
  line-height: 92px;
  box-shadow: 0px 0px 35px 0px rgba(0, 0, 0, 0.5);
  border-radius: 0px 0px 44px 44px;
}
::v-deep().overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  img {
    width: 90%;
  }
}
.historyMainClass {
  .van-pull-refresh {
    overflow: hidden;
    overflow-y: auto;
    height: calc(100vh - 350px - var(--textHeader)) !important;
  }
}
.main {
  padding-left: 24px;
  padding-bottom: 80px;
  min-height: calc(100vh - 560px - var(--textHeader));
  .van-pull-refresh {
    overflow: hidden;
    overflow-y: auto;
    height: calc(100vh - 560px - var(--textHeader));
    .sortItem:last-child {
      padding-bottom: 160px;
      /* your styles here */
    }
  }
  .van-pull-refresh::-webkit-scrollbar {
    display: none;
  }
  .item {
    margin-top: 80px;
    display: flex;
    position: relative;
    .header {
      width: 88px;
      height: 88px;
      border-radius: 88px;
      img {
        width: 88px;
        height: 88px;
      }
    }
    .editBtn {
      position: absolute;
      bottom: -90px;
      left: calc(100% - 200px);
      width: 120px;
      height: 58px;
      font-size: 28px;
      text-align: center;
      line-height: 58px;
      background: #323647;
      border-radius: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        margin-right: 8px;
        width: 32px !important;
        height: 32px !important;
      }
    }
    .text {
      margin-left: 16px;
      width: 70%;
      padding: 20px;
      background: #8368fc;
      border-radius: 24px;
      white-space: pre-line;
      word-wrap: break-word;
      font-size: 28px;
      line-height: 40px;
      color: #ffffff;
      img {
        width: 100%;
        height: auto;
      }
      div {
        margin-bottom: 10px;
      }
      span {
        margin-right: 10px;
      }
    }
  }
  .AIItem {
    margin-top: 120px;
    .noeImg {
      img {
        width: 100%;
        height: 100%;
        border-radius: 16px;
      }
    }
    .text {
      margin-left: 16px;
      width: 70%;
      background: #323647;
      position: relative;
      .list {
        display: flex;
        overflow: hidden;
        overflow-x: auto;
        .item {
          margin-right: 30px;
        }
      }
      .swiper-slide {
        width: 80%;
        img {
          border-radius: 30px;
          max-width: 100%;
          height: auto;
          width: auto;
        }
      }
      .list::-webkit-scrollbar {
        display: none;
      }
      ::v-deep().swiper-container {
        z-index: 0;
        padding-bottom: 40px;
        .swiper-pagination {
          text-align: left;
          bottom: 0px;
          span {
            margin-right: 50px;
            position: relative;
          }
          .swiper-pagination-bullet-active::after {
            content: "";
            display: block;
            height: 4px;
            background: #8368fc;
            border-radius: 3px;
          }
          .swiper-pagination-bullet {
            background: transparent;
            width: 12px;
          }
          .swiper-pagination-bullet:first-child {
            width: 180px;
          }
        }
      }
    }
    .lodaing {
      display: flex;
      justify-content: center;
    }
  }
  .quicken {
    width: 276px;
    height: 58px;
    font-size: 24px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #291d0f;
    background: linear-gradient(117deg, #fddb9e 0%, #e3b15b 100%);
    border-radius: 16px;
    position: relative;
    margin-top: 10px;
    left: calc(100% - 360px);
    img {
      width: 28px;
      height: 28px;
    }
  }
  .laud,
  .lauds {
    margin-top: 20px;
    background: #1d2234;
    padding: 16px;
    color: #ffffff;
    margin-left: 110px;
    display: inline-block;
    border-radius: 20px;
    font-size: 26px;
    // margin-bottom: 50px;
    position: relative;
  }
  .laud::after {
    position: absolute;
    left: 32px;
    top: -10px;
    content: "";
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #1d2234;
  }
  .lauds::after {
    left: 220px !important;
  }
  .p-b-120 {
    padding-bottom: 60px;
  }
  .m-b-60 {
    margin-bottom: 60px;
  }
  .btnList {
    margin-top: 12px;
    // margin-left: 110px;
    color: #ffffff;
    font-size: 26px;
    display: flex;
    justify-content: flex-end;
    margin-right: 60px;
    .editBtn {
      margin-right: 20px;
      display: flex;
      align-items: center;
      background: #323647;
      border-radius: 16px;
      padding: 11px 10px;
      img {
        margin-right: 8px;
        width: 28px;
        height: 28px;
      }
    }
  }
  .multiple {
    margin-top: 12px;
    margin-left: 110px;
    display: flex;
    width: 300px;
    padding: 15px 0;
    color: #ffffff;
    margin-bottom: 20px;
    justify-content: center;
    background: #8368fc;
    border-radius: 16px;
    font-size: 26px;
    align-items: center;
    img {
      width: 28px;
      height: 28px;
    }
  }
}
@keyframes ldio-6q3tsw3w7jf {
  0% {
    opacity: 1;
    backface-visibility: hidden;
    transform: translateZ(0) scale(1.5, 1.5);
  }
  100% {
    opacity: 0;
    backface-visibility: hidden;
    transform: translateZ(0) scale(1, 1);
  }
}
.ldio-6q3tsw3w7jf div > div {
  position: absolute;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #ffffff;
  animation: ldio-6q3tsw3w7jf 1s linear infinite;
}
.ldio-6q3tsw3w7jf div:nth-child(1) > div {
  left: 148px;
  top: 88px;
  animation-delay: -0.875s;
}
.ldio-6q3tsw3w7jf > div:nth-child(1) {
  transform: rotate(0deg);
  transform-origin: 160px 100px;
}
.ldio-6q3tsw3w7jf div:nth-child(2) > div {
  left: 130px;
  top: 130px;
  animation-delay: -0.75s;
}
.ldio-6q3tsw3w7jf > div:nth-child(2) {
  transform: rotate(45deg);
  transform-origin: 142px 142px;
}
.ldio-6q3tsw3w7jf div:nth-child(3) > div {
  left: 88px;
  top: 148px;
  animation-delay: -0.625s;
}
.ldio-6q3tsw3w7jf > div:nth-child(3) {
  transform: rotate(90deg);
  transform-origin: 100px 160px;
}
.ldio-6q3tsw3w7jf div:nth-child(4) > div {
  left: 46px;
  top: 130px;
  animation-delay: -0.5s;
}
.ldio-6q3tsw3w7jf > div:nth-child(4) {
  transform: rotate(135deg);
  transform-origin: 58px 142px;
}
.ldio-6q3tsw3w7jf div:nth-child(5) > div {
  left: 28px;
  top: 88px;
  animation-delay: -0.375s;
}
.ldio-6q3tsw3w7jf > div:nth-child(5) {
  transform: rotate(180deg);
  transform-origin: 40px 100px;
}
.ldio-6q3tsw3w7jf div:nth-child(6) > div {
  left: 46px;
  top: 46px;
  animation-delay: -0.25s;
}
.ldio-6q3tsw3w7jf > div:nth-child(6) {
  transform: rotate(225deg);
  transform-origin: 58px 58px;
}
.ldio-6q3tsw3w7jf div:nth-child(7) > div {
  left: 88px;
  top: 28px;
  animation-delay: -0.125s;
}
.ldio-6q3tsw3w7jf > div:nth-child(7) {
  transform: rotate(270deg);
  transform-origin: 100px 40px;
}
.ldio-6q3tsw3w7jf div:nth-child(8) > div {
  left: 130px;
  top: 46px;
  animation-delay: 0s;
}
.ldio-6q3tsw3w7jf > div:nth-child(8) {
  transform: rotate(315deg);
  transform-origin: 142px 58px;
}
.loadingio-spinner-spin-bjdjzuypnkp {
  width: 200px;
  height: 200px;
  display: inline-block;
  overflow: hidden;
  background: #323647 !important;
}
.ldio-6q3tsw3w7jf {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  background: #323647 !important;
  transform-origin: 0 0; /* see note above */
}
.ldio-6q3tsw3w7jf div {
  box-sizing: content-box;
}
/* generated by https://loading.io/ */
.shares {
  width: 100%;
  padding-top: 60px;
  .cavers {
    width: 702px;
    padding-bottom: 44px;
    background: url("~@/assets/shares.png") no-repeat;
    background-size: 232px 232px;
    background-position: top right;
    background-color: #daeefd;
    border-radius: 48px;
    .header {
      padding: 0 32px;
      padding-top: 58px;
      // background-image: linear-gradient(
      //     182deg,
      //     rgba(71, 140, 247, 1) 0,
      //     rgba(131, 104, 252, 1) 100%
      //   );
      overflow-wrap: break-word;
      color: rgba(21, 60, 228, 1);
      font-size: 56px;
      font-family: MyCustomFont, sans-serif;
      text-align: justify;
      white-space: nowrap;
      line-height: 63px;
      margin-left: 2px;
      // -webkit-background-clip: text;
      // -webkit-text-fill-color: transparent;
    }
    .tip {
      padding: 0 32px;
      padding-top: 14px;
      font-size: 28px;
      font-weight: 400;
      color: #8368fc;
    }
    .sharsImg {
      padding: 28px;
      img {
        border-radius: 28px;
        width: 100%;
        height: 100%;
      }
    }
    .center {
      margin: 32px;
      padding: 28px;
      background: #ffffff;
      border-radius: 24px;
    }
    .item {
      margin-top: 32px;
      display: flex;
      .sharesActive {
        width: 88px;
        height: 88px;
        border-radius: 288px;
        background: #d8d8d8;
      }
      .sharesText {
        margin-left: 16px;
        width: calc(100% - 102px);
        padding: 20px;
        border-radius: 24px;
        color: #8368fc;
        background: #e5dffe;
        font-size: 28px;
      }
    }
    .item:first-child {
      margin-top: 0;
      .sharesText {
        color: #ffffff;
        line-height: 40px;
        background: #8368fc;
      }
    }
    .qrcode {
      margin: 32px;
      margin-top: 0;
      background: #ffffff;
      border-radius: 24px;
      padding: 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .title {
        font-weight: 500;
        color: #222222;
        font-size: 28px;
      }
      .samll {
        font-weight: 300;
        color: #666666;
        font-size: 24px;
      }
      .code {
        img {
          width: 110px;
          height: 110px;
        }
      }
    }
  }
  .bottom {
    color: #ffffff;
    font-size: 30px;
    display: flex;
    justify-content: space-around;
    margin-top: 36px;
    div {
      display: flex;
      align-items: center;
      background: #8368fc;
      border-radius: 24px;
      padding: 23px 28px;
    }
    img {
      width: 48px;
      height: 48px;
    }
  }
  .close {
    position: relative;
    text-align: center;
    margin-top: 33px;
    img {
      width: 44px;
      height: 44px;
    }
  }
}
@font-face {
  font-family: "MyCustomFont"; /* 你给自定义字体起的名字 */
  src: url("@/font/douyu.otf"); /* 字体文件的路径，需要根据实际情况修改 */
}
.confirm-box {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 30px;
  border-radius: 5px;
  z-index: 9999;
}
.confirm-message {
  text-align: center;
}
.confirm-buttons {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
  div {
    text-align: center;
    margin: 0 20px;
    line-height: 60px;
    border-radius: 30px;
    background: #8368fc;
    color: #ffffff;
    width: 120px;
    height: 60px;
  }
}
/* generated by https://loading.io/ */
</style>
<style>
:root {
  /* --van-popup-background:transparent !important; */
  --van-padding-md: 0 !important;
  --van-dialog-message-font-size: 28px !important;
  --van-dialog-width: 80% !important;
  --van-dialog-message-line-height: 28px !important;
  --van-dialog-font-size: 32px !important;
  --van-button-default-font-size: 30px !important;
  --van-dialog-button-height: 80px !important;
  --van-progress-pivot-font-size: 22px !important;
}
</style>
